export default __webpack_public_path__ + "static/474-cd25e81b1815f50ec4c55e276d65ff24.gif";